import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { theme } from "theme";
import { AuthProvider } from "context/AuthContext";
import ProtectedRoute from "components/ProtectedRoute";
import Layout from "components/Layout";
import LoginPage from "pages/LoginPage";
import SignupPage from "pages/SignupPage";
import VerifyPage from "pages/VerifyPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage";
import ResetPasswordPage from "pages/ResetPasswordPage";
import DashboardPage from "pages/DashboardPage";
import OrderEntryPage from "pages/OrderEntryPage";
import OrderEntriesPage from "pages/OrderEntriesPage";
import UserStatsPage from "pages/UserStatsPage";
import CheckoutCampaignsPage from "pages/CheckoutCampaignsPage";
import CheckoutCredentialsPage from "pages/CheckoutCredentialsPage";
import CheckoutUrlsPage from "pages/CheckoutUrlsPage";
import CampaignProductsPage from "pages/CampaignProductsPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/verify" element={<VerifyPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route element={<ProtectedRoute />}>
                  <Route element={<Layout />}>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/order-entry" element={<OrderEntryPage />} />
                    <Route path="/order-entries" element={<OrderEntriesPage />} />
                    <Route path="/user-stats" element={<UserStatsPage />} />
                    <Route path="/checkout-campaigns" element={<CheckoutCampaignsPage />} />
                    <Route path="/checkout-credentials" element={<CheckoutCredentialsPage />} />
                    <Route path="/checkout-urls" element={<CheckoutUrlsPage />} />
                    <Route path="/campaign-products" element={<CampaignProductsPage />} />
                  </Route>
                </Route>
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
